<template>
  <label><slot /></label>
</template>
<style scoped>
label {
  font-size: 14px;
  color: #222;
  padding-top: 3px;
  padding-bottom: 3px;
  display: block;
}
</style>